<template>
  <v-row justify="center">
    <v-dialog
      v-model="isTheModalOpen"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      @keydown.esc="onCloseModalEvent"
    >
      <v-card>
        <!-- Toolbar -->
        <v-toolbar dark class="degrade mb-8">
          <v-toolbar-title>{{ modalTitleToolbar }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-tooltip v-if="gerarExcel" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark text v-bind="attrs" v-on="on" @click="onGenerateExcel" icon>
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>
              </template>
              <span>Gerar Excel</span>
            </v-tooltip>

            <v-tooltip v-if="gerarPdf" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark text v-bind="attrs" v-on="on" @click="onGeneratePDF" icon>
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
              </template>
              <span>Gerar PDF</span>
            </v-tooltip>
          </v-toolbar-items>
          <v-toolbar-items>
          </v-toolbar-items>
          <v-btn icon dark @click="onCloseModalEvent">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <slot></slot>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {

    };
  },

  props: {
    isTheModalOpen: Boolean,
    modalTitleToolbar: String,
    gerarPdf: Boolean,
    gerarExcel: Boolean,
  },

  methods: {
    onCloseModalEvent() {
      this.$emit("formrelatorio-close");
    },

    onGenerateExcel() {
      this.$emit("formrelatorio-excel");
    },

    onGeneratePDF() {
      this.$emit("formrelatorio-pdf");
    },

  },
};
</script>

<style>
.degrade{
 background: rgb(2,177,238);
 background: linear-gradient(90deg, rgba(2,177,238,1) 0%, rgba(37,197,213,1) 90%);
/* background-color: #222d32; */
}
</style>